import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Typography, Button, TextField } from "@material-ui/core";
import styled from "styled-components";
const StyledTypography = styled(Typography)`
    margin-top: 15px !important ;
`;
const StyledDiv = styled.div`
    display: flex;
`;
export default (props) => {
    const [qualificationTitle, setQualificationTitle] = useState("");

    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader>Create Custom Qualification</ModalHeader>
            <ModalBody>
                <StyledTypography variant="body2">
                    Please Enter Qualification Title
                </StyledTypography>
                <StyledDiv>
                    <Typography
                        style={{ paddingTop: 20, marginRight: 10 }}
                        variant="subtitle2"
                    >
                        <b>{props.newQualificationInfo.prefix}:</b>
                    </Typography>

                    <TextField
                        style={{
                            minWidth: 300,
                        }}
                        label={`Qualification Title ${
                            qualificationTitle === "" ? "(Mandatory)" : ""
                        }`}
                        onChange={(event) =>
                            setQualificationTitle(event.target.value)
                        }
                        value={qualificationTitle}
                    />
                </StyledDiv>
                <StyledTypography>
                    This Will Then Be Available To Add To Required
                    Qualifications From Available Qualifications
                </StyledTypography>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => {
                        setQualificationTitle("");
                        props.setModalState();
                    }}
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    disabled={qualificationTitle === "" ? true : false}
                    onClick={() => {
                        setQualificationTitle("");
                        props.setModalState();
                        props.createCustomQualification(
                            props.newQualificationInfo.id,
                            `${props.newQualificationInfo.prefix} - ${qualificationTitle}`
                        );
                    }}
                    variant="contained"
                    color="primary"
                >
                    Create
                </Button>
            </ModalFooter>
        </Modal>
    );
};
